module.exports = __webpack_public_path__ + "assets/img/logout.dbf22412.svg";